import { Badge } from "@/components/ui/badge";
import {
  BadgeCheck,
  AlertTriangle,
  UserCheck,
  Clock,
  CircleDollarSign,
  Loader2,
  PauseCircle,
  XCircle,
  CheckCircle2,
  Circle,
} from "lucide-react";

const STATUS_MAP = {
  verified: {
    label: "Verified",
    icon: BadgeCheck,
    className:
      "bg-[hsl(var(--status-verified)/0.15)] text-[hsl(var(--status-verified))] border-[hsl(var(--status-verified)/0.35)]",
  },
  mismatched: {
    label: "Mismatch",
    icon: AlertTriangle,
    className:
      "bg-[hsl(var(--status-mismatch)/0.15)] text-[hsl(var(--status-mismatch))] border-[hsl(var(--status-mismatch)/0.35)]",
  },
  customer_verified: {
    label: "Customer Verified",
    icon: UserCheck,
    className:
      "bg-[hsl(var(--status-customer-verified)/0.15)] text-[hsl(var(--status-customer-verified))] border-[hsl(var(--status-customer-verified)/0.35)]",
  },
  pending: { label: "Pending", icon: Clock, className: "bg-muted text-foreground border-border" },
  paid: {
    label: "Paid",
    icon: CircleDollarSign,
    className:
      "bg-[hsl(var(--status-verified)/0.12)] text-[hsl(var(--status-verified))] border-[hsl(var(--status-verified)/0.25)]",
  },
  unpaid: { label: "Unpaid", icon: Circle, className: "bg-secondary text-muted-foreground border-border" },
  new: { label: "New", icon: Clock, className: "bg-secondary text-foreground border-border" },
  processing: {
    label: "Processing",
    icon: Loader2,
    className:
      "bg-[hsl(var(--status-customer-verified)/0.12)] text-[hsl(var(--status-customer-verified))] border-[hsl(var(--status-customer-verified)/0.25)]",
  },
  on_hold: {
    label: "On Hold",
    icon: PauseCircle,
    className:
      "bg-[hsl(var(--status-on-hold)/0.12)] text-[hsl(var(--status-on-hold))] border-[hsl(var(--status-on-hold)/0.25)]",
  },
  cancelled: {
    label: "Cancelled",
    icon: XCircle,
    className:
      "bg-[hsl(var(--status-cancelled)/0.12)] text-[hsl(var(--status-cancelled))] border-[hsl(var(--status-cancelled)/0.25)]",
  },
  completed: {
    label: "Completed",
    icon: CheckCircle2,
    className:
      "bg-[hsl(var(--status-verified)/0.12)] text-[hsl(var(--status-verified))] border-[hsl(var(--status-verified)/0.25)]",
  },
};

export const StatusBadge = ({ status, testid }) => {
  const config = STATUS_MAP[status] || { label: status, icon: Circle, className: "bg-muted text-foreground border-border" };
  const Icon = config.icon;
  return (
    <Badge variant="outline" data-testid={testid} className={`gap-1 font-medium ${config.className}`}>
      <Icon className="h-3 w-3" aria-hidden="true" />
      {config.label}
    </Badge>
  );
};
